const oralSurgery = {
  hero: {
    badgeIconAlt: "Икона Орална Хирургия",
    badgeText: "Прецизни Орални Процедури",
    titleLine1: "Съвременни Решения в",
    titleLine2: "Оралната Хирургия",
    description:
      "Нашите експертни орални хирурзи предоставят прецизно лечение за екстракции, проблеми с челюстта и орални патологии, използвайки най-съвременни техники за по-бързо възстановяване и оптимални резултати.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Научете за Процеса",
    },
    heroImageAlt: "Съвременна Орална Хирургия",
    stats: {
      successRateLabel: "Успеваемост",
      successRateValue: "97%+",
      recoveryLabel: "Възстановяване",
      recoveryValue: "По-бързо",
    },
    experience: {
      label: "Хирургично Съвършенство",
      value: "12+ Години Опит",
    },
  },
  benefits: {
    heading: "ЗАЩО ДА ИЗБЕРЕТЕ ОРАЛНА ХИРУРГИЯ ПРИ НАС",
    intro: "Изпитайте най-съвременните хирургични процедури с оптимални резултати и комфорт.",
    items: [
      {
        title: "Прецизно Лечение",
        description:
          "Нашите хирурзи използват съвременни образни и микрохирургични техники за най-високо ниво на прецизност при всяка процедура",
      },
      {
        title: "Минимален Дискомфорт",
        description:
          "Модерните възможности за анестезия и минимално инвазивните техники осигуряват вашия комфорт преди, по време и след хирургичните процедури.",
      },
      {
        title: "По-бързо Възстановяване",
        description:
          "Използваните от нас методи и подходи в лечението спомагат за по -бърз оздравителен процес.",
      },
    ],
  },
  process: {
    heading: "ХИРУРГИЧНИЯТ ПРОЦЕС",
    intro: "Нашият оптимизиран подход осигурява изключителна грижа и резултати.",
    steps: [
      {
        title: "Цялостна Оценка",
        description:
          "Започваме с обстоен преглед на вашето орално здраве, медицинска история и образна диагностика, за да разработим персонализиран план за лечение.",
      },
      {
        title: "Предоперативна Подготовка",
        description:
          "Обсъждаме възможностите за анестезия, предоставяме подробни предоперативни инструкции и отговаряме на всички ваши въпроси, за да сте напълно подготвени.",
      },
      {
        title: "Прецизна Хирургична Процедура",
        description:
          "Използвайки съвременни техники и технологии, нашите хирурзи извършват процедурата с изключителна прецизност и грижа.",
      },
      {
        title: "Следоперативни Грижи",
        description:
          "Предоставяме подробни инструкции за следоперативна грижа и проследяване, за да осигурим оптимално възстановяване и резултати.",
      },
    ],
  },
  faq: {
    heading: "ЧЕСТО ЗАДАВАНИ ВЪПРОСИ",
    intro: "Получете отговори на често задавани въпроси за нашите орално-хирургични процедури.",
    items: [
      {
        question: "Какви видове орална хирургия извършвате?",
        answer:
          "Предлагаме широка гама от орални хирургични процедури, включително премахване на мъдреци, зъбни импланти, костна присадка, челюстна хирургия, биопсии и лечение на лицеви травми и инфекции.",
      },
      {
        question: "Как да се подготвя за орална хирургия?",
        answer:
          "Подготовката зависи от конкретната процедура. Обикновено трябва да следвате инструкциите за гладуване, ако получавате седация, да организирате транспорт до дома, да носите удобно облекло и да следвате всички предоперативни инструкции, предоставени от нашия екип.",
      },
      {
        question: "Колко време отнема възстановяването?",
        answer:
          "Времето за възстановяване варира в зависимост от процедурата и индивидуалните фактори на заздравяване. Простите екстракции може да изискват само няколко дни, докато по-сложните операции може да се нуждаят от 1-2 седмици за първоначално възстановяване. Ще предоставим конкретни очаквания за времето според вашата процедура.",
      },
      {
        question: "Болезнена ли ще бъде процедурата?",
        answer:
          "Вашият комфорт е наш приоритет. Използваме съвременни техники за анестезия, за да гарантираме, че няма да чувствате болка по време на процедурата. Следоперативният дискомфорт се управлява с подходящи болкоуспокояващи и подробни инструкции за следоперативна грижа.",
      },
      {
        question: "Какви са рисковете, свързани с оралната хирургия?",
        answer:
          "Въпреки че оралната хирургия обикновено е безопасна, всички хирургични процедури носят някои рискове, които могат да включват инфекция, кървене, увреждане на нерви или реакции към анестезията. Обсъждаме подробно всички потенциални рискове и вземаме обширни предпазни мерки, за да ги сведем до минимум.",
      },
    ],
  },
};

export default oralSurgery;

